<div class="avatar">
  <div class="avatar__img">
    <img *ngIf="(user$ | async)?.avatar ?? avatar, else userInitials"
         [src]="(user$ | async)?.avatar ?? avatar"/>

    <ng-template #userInitials>
      {{ (user$ | async)?.first_name.substring(0, 1) | uppercase }}{{ (user$ | async)?.last_name.substring(0, 1) | uppercase }}
    </ng-template>
  </div>

  <ng-content></ng-content>
</div>
